/**
 * ユーザー名の取得
 *
 * @param {string} userName - ユーザー名
 * @param {string} userId - 退会済みかどうかを判定する ID (null の場合は退会済ユーザー)
 * NOTE: 依頼者ユーザーID, 受注者ユーザーIDなど退会済みかを判定できる ID を想定
 */
export const getUserNickName = (userName: string, userId: string | null): string => {
  if (!userId) {
    return "退会済ユーザー";
  }
  // NOTE: ユーザー名の指定なければユーザー ID を返す
  return userName ? userName : userId;
};
